<template>
  <div class="ImageGallery row">
    <div
      role="button"
      aria-pressed="false"
      tabindex="0"
      :key="image.id"
      v-for="image in images"
      class="col-12 cursor-pointer image"
      :class="[`col-md-${colSize}`]"
      @click.prevent="showModal(image.id)"
      @keyup.enter="showModal(image.id)"
      @keyup.space="showModal(image.id)"
    >
      <div v-if="byggnadsinfo">
        <b-aspect ref="byggnadsInfoImage" aspect="1:1" :style="{ backgroundImage: 'url(' + image.path + ')', backgroundSize: 'cover' }"></b-aspect>
      </div>
      <div v-else-if="ksamsok">
        <b-aspect
            ref="ksamSokImage"
            aspect="1:1"
            role="img"
            :aria-label="image.title"
            :style="{ backgroundImage: 'url(' + getThumbnailFromKsam(image.src) + ')', backgroundSize: 'cover' }"
        ></b-aspect>
      </div>
      <div v-else-if="digitaltMuseum">
        <b-aspect
            ref="ksamSokImage"
            aspect="1:1"
            role="img"
            :aria-label="image.title"
            :style="{ backgroundImage: 'url(' + getThumbnailFromDigitaltMuseum(image.src) + ')', backgroundSize: 'cover' }"
        ></b-aspect>
      </div>
      <div v-else>
        <aws-image :src="image.path" :width="imageSize.width" :height="imageSize.height" :alt="image.alt_text" fit="cover"></aws-image>
          <h5 class="image-title">{{ image.title }}</h5>
      </div>
    </div>
    <b-modal
            :id="modalId"
            size="xl"
            hide-footer
            :title="currentImage && currentImage.title"
            :content-class="contentClass"
            body-class="p-0"
            @shown="modalOpen = true"
            @hidden="modalOpen = false"
    >
      <div class="w-100 h-100 position-relative">
        <div class="w-100 d-flex justify-content-between align-items-center nav-wrapper"  v-if="_.size(images) > 1">
          <div class="arrow-wrapper" :class="minReached && 'opacity-25'" @click="currentItem > 0 && currentItem--">
            <i class="fas fa-chevron-left fa-2x cursor-pointer" />
          </div>
          <div class="arrow-wrapper" :class="maxReached && 'opacity-25'" @click="currentItem < numImages - 1 && currentItem++">
            <i class="fas fa-chevron-right fa-2x cursor-pointer" />
          </div>
        </div>
        <div v-if="isLoading" class="bg-white py-5 d-flex justify-content-center align-items-center min-vw-40 w-100">
          <i class="fas fa-spinner fa-spin fa-4x" />
        </div>
        <div v-else-if="byggnadsinfo">
          <div class="p-5 mx-auto" v-html="html"></div>
        </div>
        <div v-else-if="isImage">
          <image-template :html="html"></image-template>
        </div>
        <div v-else v-html="html"></div>

      </div>
<!--      <template v-slot:modal-footer>-->
<!--        <div class="w-100 text-white d-flex justify-content-between position-relative">-->
<!--          <i class="fas fa-chevron-left fa-2x cursor-pointer" :class="minReached && 'opacity-25'" @click="currentItem > 0 && currentItem&#45;&#45;" />-->
<!--          <div class="flex-1 text-center">-->
<!--            <i :key="image.id" :class="currentItem === index ? 'fas fa-circle mx-1' : 'far fa-circle mx-1'" class="cursor-pointer" v-for="(image, index) in images" @click="currentItem = index" />-->
<!--          </div>-->
<!--          <i class="fas fa-chevron-right fa-2x cursor-pointer" :class="maxReached && 'opacity-25'" @click="currentItem < numImages - 1 && currentItem++" />-->
<!--        </div>-->
<!--      </template>-->
    </b-modal>
  </div>
</template>

<script>

import ImageTemplate from './ImageTemplate'
export default {
  components: { ImageTemplate },
  props: ['images', 'id', 'byggnadsinfo', 'ksamsok', 'digitaltMuseum'],

  data: function () {
    return {
      numImages: _.size(this.images),
      html: null,
      modalId: this.id,
      currentItem: null,
      currentImage: null,
      modalOpen: false,
      baseUrl: process.env.MIX_ASSET_URL,
      hasRelatedPlaces: false,
      isLoading: false
    }
  },

  mounted () {
    this.$store.dispatch('setScrollPos')

    document.addEventListener('keyup', this.onKeyUp)
  },

  methods: {
    getHtmlForModal: function (id) {
      this.isLoading = true
      if (this.byggnadsinfo) {
        const url = window.getComputedStyle(this.$refs.byggnadsInfoImage[this.currentItem].$el, null)
          .getPropertyValue('background-image')
          .slice(4, -1)
          .replace(/"/g, '')
          .replace('small', 'large')
        this.html = `<div>
            <img src="${url}" class="img-fluid" />
            Detta material är insamlat av länsmuseets byggnadsantikvarier under lång tid och det
            förekommer bilder av privatägda fastigheter. Har du synpunkter på publiceringen,
            hör av dig till oss på: <a href="mailto:lansmuseet@regionvastmanland.se">lansmuseet@regionvastmanland.se</a>
            </div>`
      } else if (this.ksamsok) {
        const image = _.find(this.images, { id: id })
        const url = _.get(_.find(image.src, s => s.type === 'highres'), 'content') ||
                _.get(_.find(image.src, s => s.type === 'lowres'), 'content') ||
                _.get(_.find(image.src, s => s.type === 'thumbnail'), 'content')

        this.html = `
                <article class="p-5 bg-white card">
                    <h1>${image.title}</h1>
                    <div class="d-flex mb-2 pb-3">
                        <div>Fotograf: <strong>${image.byline}</strong></div>
                    </div>
                    <div class="d-flex">
                        <div class="row w-100">
                          <div class="col-12">
                            <img src="${url}" class="img-fluid" />
                          </div>
                        </div>
                    </div>
                </article>
        `
      } else if (this.digitaltMuseum) {
        const image = _.find(this.images, { id: id })
        const url = `${image.src}?dimension=1200x1200`
        this.html = `
                <article class="p-5 bg-white card">
                    <h1>${image.title}</h1>
                    <div class="d-flex">
                        <div class="row w-100">
                          <div class="col-12">
                            <img src="${url}" class="img-fluid" />
                          </div>
                        </div>
                    </div>
                </article>
        `
      } else {
        return axios.get(`${process.env.MIX_ASSET_URL}/bild/${id}/content`)
          .then(response => response.data)
          .then(html => {
            // console.log(html)
            const tmpDiv = document.createElement('div')
            tmpDiv.innerHTML = html
            const mapComponent = tmpDiv.getElementsByTagName('map-component')[0]
            // console.log(mapComponent)
            if (mapComponent) {
              this.hasRelatedPlaces = true
            }
            this.html = html
          })
      }
    },

    showModal: async function (id) {
      this.currentItem = _.findIndex(this.images, { id: id })
      await this.getHtmlForModal(id)
      this.$bvModal.show(this.modalId)
    },

    onKeyUp: function (event) {
      if (this.modalOpen) {
        if (event.keyCode === 37 && this.currentItem > 0) {
          this.currentItem--
        } else if (event.keyCode === 39 && this.currentItem < this.numImages - 1) {
          this.currentItem++
        } else if (event.keyCode === 27) {
          this.$bvModal.hide(this.modalId)
        }
      }
    },

    getThumbnailFromKsam: function (src) {
      const sizeToGet = this.numImages > 3 ? 'thumbnail' : 'lowres'
      return _.get(_.find(src, s => s.type === sizeToGet), 'content')
    },

    getThumbnailFromDigitaltMuseum: function (src) {
      const sizeToGet = this.numImages > 3 ? '?dimension=250x250' : '?dimension=600x600'
      return `${src}${sizeToGet}`
    }
  },

  computed: {
    colSize: function () {
      return this.numImages < 3 ? 4 : 12 / this.numImages < 3 ? 3 : 12 / this.numImages
    },
    imageSize: function () {
      const width = this.numImages < 3 ? 1200 : this.numImages > 2 ? 300 : 600
      return {
        width: width,
        // height: this.numImages > 2 ? 300 : Math.floor(width / 1.7778)
        height: this.numImages > 2 ? 300 : null
      }
    },
    minReached: function () {
      return this.currentItem === 0
    },
    maxReached: function () {
      return this.currentItem === this.numImages - 1
    },
    contentClass: function () {
      return (this.byggnadsinfo || this.ksamsok) ? 'image-gallery-modal byggnadsinfo' : 'image-gallery-modal'
    },
    isImage: function () {
      return !this.byggnadsinfo && !this.ksamsok && !this.digitaltMuseum
    }
  },

  watch: {
    currentItem: function (newItem) {
      this.currentImage = this.images[newItem]
      this.getHtmlForModal(this.images[newItem].id)
    },
    html: function (newHtml, oldHtml) {
      if (newHtml !== oldHtml) {
        this.isLoading = false
      }
    }
  }
}
</script>
